class ShoppableImage extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.shoppable === 'true') {
      this.bindShoppableEvents();
      this.addPoppers();
    } else {
      this.observer = new IntersectionObserver((entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            this.timeout = setTimeout(this.showDots.bind(this), 500);
          } else {
            clearTimeout(this.timeout);
            this.hideDots();
          }
        }
      }, { threshold: [0.75] });
  
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  async addPoppers() {
    await new Promise((resolve) => window.loadScript(window.scripts.popper, resolve));

    const region = this.querySelector('.shoppable-image__region');

    this.querySelectorAll('.shoppable-image__area').forEach((area) => {
      const anchor = area.querySelector('.shoppable-image__dot');
      const tooltip = area.querySelector('.shoppable-image__tag');

      let placement = 'right';

      if (tooltip.classList.contains('shoppable-image__tag--top')) {
        placement = 'top';
      } else if (tooltip.classList.contains('shoppable-image__tag--left')) {
        placement = 'left';
      } else if (tooltip.classList.contains('shoppable-image__tag--right')) {
        placement = 'right';
      } else if (tooltip.classList.contains('shoppable-image__tag--bottom')) {
        placement = 'bottom';
      } else if (tooltip.classList.contains('shoppable-image__tag--top-left')) {
        placement = 'top-start';
      } else if (tooltip.classList.contains('shoppable-image__tag--top-right')) {
        placement = 'top-end';
      } else if (tooltip.classList.contains('shoppable-image__tag--bottom-left')) {
        placement = 'bottom-start';
      } else if (tooltip.classList.contains('shoppable-image__tag--bottom-right')) {
        placement = 'bottom-end';
      }

      window.Popper.createPopper(anchor, tooltip, {
        placement,
        modifiers: [
          {
            name: 'flip',
            enabled: false
          },
          {
            name: 'preventOverflow',
            options: {
              boundary: region
            }
          },
          {
            name: 'arrow',
            options: {
              padding: {
                bottom: 16
              }
            }
          }
        ]
      });
      
      tooltip.classList.remove('js-hidden');
    });

    setTimeout(() => {
      this.querySelector(".shoppable-image").classList.remove(
        "shoppable-image--hidden-dots"
      );
      requestAnimationFrame(() => {
        this.showDots();
      });
    }, 500);
  }

  bindShoppableEvents() {
    this.querySelectorAll(".shoppable-image__region a").forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        document
          .querySelector(element.getAttribute("href"))
          .scrollIntoView({ behavior: "smooth" });
      });
    });
    this.querySelector(".shoppable-image__link").addEventListener(
      "click",
      (event) => {
        event.preventDefault();
      }
    );
    this.addEventListener("click", () => {
      this.querySelector(".shoppable-image").classList.toggle(
        "shoppable-image--hidden-dots"
      );
    });
    [...this.querySelectorAll(".shoppable-image__area")].forEach((element) => {
      element.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      element.addEventListener("mouseenter", (event) => {
        this.hideAreas();
        this.showArea(event.target);
      });
      element.addEventListener("mouseleave", () => {
        this.hideAreas();
      });
    });
    [...this.querySelectorAll(".shoppable-image__dot")].forEach((element) => {
      element.addEventListener("focus", (event) => {
        this.hideAreas();
        this.showArea(event.target.parentElement);
      });
      element.addEventListener("touchstart", (event) => {
        event.preventDefault();
        this.showDots();
        if (
          event.target.parentElement.classList.contains(
            "shoppable-image__area--active"
          )
        ) {
          this.hideAreas();
        } else {
          this.hideAreas();
          this.showArea(event.target.parentElement);
        }
      });
    });
    this.addEventListener("mouseleave", () => {
      this.hideAreas();
      const area = this.querySelector(".shoppable-image__area");
      this.showArea(area);
    });
  }

  showArea(element) {
    element.classList.add("shoppable-image__area--active");
    element
      .querySelector(".shoppable-image__tag")
      .setAttribute("aria-hidden", false);
  }

  hideAreas() {
    [...this.querySelectorAll(".shoppable-image__area")].forEach((element) => {
      element.classList.remove("shoppable-image__area--active");
      element
        .querySelector(".shoppable-image__tag")
        .setAttribute("aria-hidden", true);
    });
  }

  showDots() {
    this.querySelector(".shoppable-image").classList.add(
      "shoppable-image--visible-dots"
    );
  }

  hideDots() {
    this.querySelector(".shoppable-image").classList.remove(
      "shoppable-image--visible-dots"
    );
  }
}

customElements.define("shoppable-image", ShoppableImage);
